<template>
    <div class="course-container">
        <!--详情-->
        <div class="lesson-container" v-show="this.showMode==='view'">
            <div class="top-title">个人备课详情</div>
            <div class="info-column-container">
                <div class="flex-item column-title">基本信息</div>
                <div class="flex-item column-status" v-if="lessonInfo.status===1">初始</div>
                <div class="flex-item column-status-fb" v-if="lessonInfo.status===9">备课完成</div>
                <div class="flex-item column-btn">
                    <div class="btn" v-if="lessonInfo.status===1" @click="editLesson">
                        编辑
                    </div>
                    <div class="btn" v-if="lessonInfo.status===1" @click="handleRelease">
                        完成备课
                    </div>
                </div>
            </div>
            <div class="base-info-container">
                <div class="base-info-content">
                    <div class="info-lesson-title">
                        [个人备课]{{lessonInfo.title}}
                    </div>
                    <div class="info-item-column" style="margin-top: 10px">
                        <div class="info-item-subject">学科信息：{{lessonInfo.periodName}}、{{lessonInfo.gradeName}}、{{lessonInfo.subjectName}}</div>
                        <div class="info-item-level">课题级别：{{lessonInfo.lessonLevelName}}</div>
                    </div>
                    <div class="info-item-column">
                        <div class="info-label">主备人：</div>
                        <div>{{lessonInfo.leadUserName}}</div>
                    </div>
                    <div class="info-item-column">
                        <div class="info-label">备课时间：</div>
                        <div>{{ timestampToTime(lessonInfo.createTime) }}</div>
                    </div>
                </div>
                <div class="base-info-cover">
                    <img class="img-100"  :src="lessonInfo.coverUrl" alt="">
                </div>
            </div>

            <div class="info-column-container">
                <div class="column-title">附件内容</div>
            </div>
            <div class="file-info-container">
                <!--教案-->
                <div class="file-container" v-if="jaFiles&&jaFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">教案</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in jaFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--学案-->
                <div class="file-container" v-if="xaFiles&&xaFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">学案</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in xaFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--课件-->
                <div class="file-container" v-if="kjFiles&&kjFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">课件</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in kjFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!--习题-->
                <div class="file-container" v-if="xtFiles&&xtFiles.length>0">
                    <div class="file-type">
                        <div class="file-classify">习题</div>
                    </div>
                    <div class="file-list">
                        <div class="file-item" v-for="item in xtFiles" :key="item">
                            <div class="file-title">{{item.fileName}}</div>
                            <div class="file-view" v-if="!judgeIsPPT(item.fileType)">
                                <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/file_view.png')"
                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                </el-image>
                            </div>
                            <div class="file-view" v-if="judgeIsPPT(item.fileType)">
                                <el-image @click="viewPPTFile(item.fileUrl)" class="file-icon" style="margin-top: 2px"
                                          :src="require('@/assets/file/ppt_play.png')">
                                </el-image>
                            </div>
                            <div class="file-download">
                                <img class="file-icon" @click="downloadFile(item)" src="../../assets/file/file_download.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--编辑-->
        <div class="lesson-container" v-show="this.showMode==='edit'">
            <div class="top-title">编辑个人备课</div>
            <el-form ref="form" :model="lessonInfo" :rules="rules" label-width="100px">
                <div class="info-column-container">
                    <div class="column-title">基本信息</div>
                </div>
                <el-row class="mt10">
                    <el-col :span="8">
                        <el-form-item label="学段" prop="periodKey">
                            <el-select @change="changePeriod" v-model="lessonInfo.periodKey" placeholder="请选择学段">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="年级" prop="gradeKey">
                            <el-select @change="changeGrade" v-model="lessonInfo.gradeKey" placeholder="请选择年级">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="学科" prop="subjectKey">
                            <el-select v-model="lessonInfo.subjectKey" placeholder="请选择学科">
                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="mt10">
                    <el-col :span="16">
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="备课标题" prop="title">
                                    <el-input v-model="lessonInfo.title" placeholder="请输入备课标题"  />
                                </el-form-item>
                            </el-col>
                            <el-col :span="4">
                                <el-icon @click="queryDirectory" class="cursor" :size="24" style="margin-top: 3px;margin-left: 7px;">
                                    <Notebook></Notebook>
                                </el-icon>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="课题级别" prop="lessonLevelKey">
                                    <el-select style="width: 100%;" v-model="lessonInfo.lessonLevelKey" placeholder="请选择课题级别">
                                        <el-option v-for="item in lessonLevelList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="20">
                                <el-form-item label="备课人" prop="leadUserName">
                                    <el-input v-model="lessonInfo.leadUserName" disabled />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="封面" prop="coverUrl">
                            <el-upload class="avatar-uploader"
                                       :action="serviceUrl+'/businessservice/lesson/uploadGrCover'"
                                       :show-file-list="false" :on-success="handleCoverSuccess" :headers="{ token }"
                                       :before-upload="beforeCoverUpload">
                                <img v-if="lessonInfo.coverUrl" :src="lessonInfo.coverUrl" class="img-100 avatar" style="position:absolute" />
                                <el-icon v-else class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                            <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="info-column-container">
                    <div class="column-title">附件内容</div>
                </div>
                <el-row class="mt10">
                    <el-col :span="12">
                        <el-form-item label="上传教案" prop="">
                            <el-upload v-model:file-list="jAFileList" class="upload-demo" :on-remove="handleRemove"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :on-change="handleJAChange" :headers="{ token }"
                                       :data="{ fileType: 1, lessonType: 1, lessionId: lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="上传学案" prop="">
                            <el-upload v-model:file-list="xAFileList" class="upload-demo" :on-remove="handleRemove"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :on-change="handleXAChange" :headers="{ token }"
                                       :data="{ fileType: 4, lessonType: 1, lessionId: lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="上传课件" prop="">
                            <el-upload v-model:file-list="kJFileList" class="upload-demo" :on-remove="handleRemove"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :on-change="handleKjChange" :headers="{ token }"
                                       :data="{ fileType: 2, lessonType: 1, lessionId: lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="上传习题" prop="">
                            <el-upload v-model:file-list="xTFileList" class="upload-demo" :on-remove="handleRemove"
                                       :action="serviceUrl+'/businessservice/lesson/uploadFile'"
                                       :on-change="handleXTChange" :headers="{ token }"
                                       :data="{ fileType: 3, lessonType: 1, lessionId: lessonId }"
                                       accept=".pdf,.ppt,.pptx,.doc,.docx" :before-upload="beforeJAUpload">
                                <el-button type="primary">点击上传</el-button>
                                <template #tip>
                                    <div class="el-upload__tip">
                                        只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                    </div>
                                </template>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="disflex-row-center">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>

        <el-dialog title="课程目录" v-model="isDirectory" width="60%">
            <el-row>
                <el-empty v-if="directoryList.length == 0" style="margin: 0 auto;" description="暂无数据" />
                <div style="margin-bottom: 15px;margin-right:40px;" v-for="item in directoryList">
                    <el-card @click="goCourse(item)" class="cursor" style="width: 150px;">
                        <div class="csbbb">
                            <el-image fit="cover" style="width: 130px;height:185px" :src="item.coverUrl"></el-image>
                        </div>
                        <div class="mt5 text-one">{{ item.className }}</div>
                    </el-card>
                </div>
            </el-row>
        </el-dialog>

        <el-dialog title="课程目录" v-model="isCourse" width="60%">
            <el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
                <el-table-column prop="ptit" label="单元名" width="180">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;">
                            <div @click="changeTitle(scope.row)" :style="scope.row.title ? '' : 'color: #409efe;'"
                                 :class="scope.row.title ? '' : 'cursor'" :title="scope.row.ptit" style="" class="text-one ">
                                {{ scope.row.ptit }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="课程名">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;" v-if="scope.row.id">
                            <div @click="changeTitle(scope.row)" :title="scope.row.title" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.title }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>

import { timestampToTime } from "@/utils/date";
import {delLessonFile, lessonInfo, lessonEnd, lessonUpdate} from "@/api/admin/lesson"
import {downloadFile} from "@/api/adminservice/public";
import {queryDict} from "@/api/admin/public";
import { serviceUrl } from "@/utils/global"
import {classLibraryListAllBook, classLibraryListTree} from "@/api/admin/classLibrary";

export default {
    name: "preLessonInfo",
    components: {},
    props:{
        lessonId:{
            type: String,
            default:null,
        },
    },
    watch:{
        lessonId(newValue,oldValue){
            this.queryLessonInfo()
        },
    },
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            viewMode:'view',
            editMode:'edit',
            showMode:'view',
            timestampToTime,
            lessonInfo:{},
            jaFiles:[],//教研
            xaFiles:[],//学案
            kjFiles:[],//课件
            xtFiles:[],//习题
            // 表单校验
            isDirectory: false,
            isCourse: false,
            periodList: [],
            gradeList: [],
            subjectList: [],
            directoryList: [],
            tableData: [],
            lessonLevelList:[],
            jAFileList: [],
            xAFileList: [],
            kJFileList: [],
            xTFileList: [],
            delFileList: [],

            rules: {
                lessonNature: [
                    { required: true, message: "请选择备课性质", trigger: "change" },
                ],
                groupId: [
                    { required: true, message: "请选择工作室/群组", trigger: "change" },
                ],
                periodKey: [
                    { required: true, message: "请选择学段", trigger: "change" },
                ],
                gradeKey: [
                    { required: true, message: "请选择年级", trigger: "change" },
                ],
                subjectKey: [
                    { required: true, message: "请选择学科", trigger: "change" },
                ],
                lessonLevelKey: [
                    { required: true, message: "请选择课题级别", trigger: "change" },
                ],
                title: [
                    { required: true, message: "请输入备课标题", trigger: "blur" },
                ],
                leadUser: [
                    { required: true, message: "请选择主备人", trigger: "change" },
                ],
                formTime: [
                    { required: true, validator: this.checkValidator }
                ],
            },
        };
    },
    created() {
        this.getQueryDict()
    },
    mounted() {
        this.queryLessonInfo()
    },
    computed: {},
    methods: {
        editLesson(){
            this.showMode = this.editMode;
        },
        cancel(){
            this.showMode = this.viewMode;
        },
        queryLessonInfo(){
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
                lessonInfo({ lessonId: this.lessonId }).then(res => {
                    if (res.data.code===1){
                        this.lessonInfo = res.data.data;
                        this.jaFiles = []
                        this.xaFiles = []
                        this.kjFiles = []
                        this.xtFiles = []
                        this.jaFiles = this.lessonInfo.gajaFiles;
                        this.xaFiles = this.lessonInfo.gaxaFiles;
                        this.kjFiles = this.lessonInfo.gakjFiles;
                        this.xtFiles = this.lessonInfo.gaxtFiles;
                        this.showMode = this.viewMode;
                        this.lessonInfo.gajaFiles.forEach(e => {
                            this.jAFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.gaxaFiles.forEach(e => {
                            this.xAFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.gakjFiles.forEach(e => {
                            this.kJFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.lessonInfo.gaxtFiles.forEach(e => {
                            this.xTFileList.push({
                                name: e.fileName,
                                fileId: e.fileId,
                                url: e.fileUrl,
                                response: {
                                    data: e.fileUrl
                                }
                            })
                        })
                        this.periodList.forEach(j => {
                            if (this.lessonInfo.periodKey === j.dictKey) {
                                this.gradeList = j.childrenList;
                            }
                        })
                        this.periodList.forEach(e => {
                            if (this.lessonInfo.periodKey === e.dictKey) {
                                e.childrenList.forEach(j => {
                                    if (this.lessonInfo.gradeKey === j.dictKey) {
                                        this.subjectList = j.childrenList;
                                    }
                                })
                            }
                        })
                    }
                })
            })

        },
        viewFile(file){},
        viewPPTFile(fileUrl){
            const openUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' +fileUrl;
            window.open(openUrl, '_blank')
        },
        judgeIsPPT(fileType){
            // if (!fileType){
            //     return false;
            // }
            // return fileType.toLowerCase().includes("ppt");
            return false;
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png');
            }
            return list;
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'topic_level' }).then(res => {
                this.lessonLevelList = res.data.data;
            })
        },
        changePeriod() {
            this.lessonInfo.gradeKey = '';
            this.lessonInfo.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.lessonInfo.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        changeGrade() {
            this.lessonInfo.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.lessonInfo.periodKey == e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.lessonInfo.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
        },
        handleCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.lessonInfo.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeCoverUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        queryDirectory() {
            classLibraryListAllBook().then(res => {
                if (this.lessonInfo.periodKey !== '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.periodKey == this.lessonInfo.periodKey
                    })
                }
                if (this.lessonInfo.gradeKey !== '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.gradeKey == this.lessonInfo.gradeKey
                    })
                }
                if (this.lessonInfo.subjectKey !== '') {
                    res.data.data = res.data.data.filter(itemA => {
                        return itemA.subjectKey == this.lessonInfo.subjectKey
                    })
                }
                this.directoryList = JSON.parse(JSON.stringify(res.data.data));
                this.isDirectory = true;
            });
        },
        goCourse(item) {
            this.tableData = []
            classLibraryListTree().then(res => {
                res.data.data.forEach(e => {
                    if (item.classId == e.classId) {
                        if (e.childrenList) {
                            e.childrenList.forEach(j => {
                                if (j.childrenList) {
                                    j.childrenList.forEach((m, n) => {
                                        if (n == 0) {
                                            this.tableData.push({ pid: j.classId, ptit: j.className, id: m.classId, title: m.className, col: j.childrenList.length, className: e.className })
                                        } else {
                                            this.tableData.push({ pid: j.classId, ptit: j.className, id: m.classId, title: m.className, col: 0, className: e.className })
                                        }
                                    })
                                } else {
                                    this.tableData.push({ pid: j.classId, ptit: j.className, id: '', title: '', col: 1, className: e.className })
                                }
                            })
                        }
                    }
                })
                this.isCourse = true
            })
        },
        changeTitle(row) {
            this.lessonInfo.title = row.className + '­—' + row.ptit + (row.title ? '­—' + row.title : '')
            this.isDirectory = false;
            this.isCourse = false;
        },
        objectSpanMethod(e) {
            // console.log(e);
            if (e.columnIndex === 0) {
                if (e.row.col != 0) {
                    return {
                        rowspan: e.row.col,
                        colspan: 1,
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    }
                }
            }
        },

        handleXTChange(file) {
            console.log(file)
        },
        handleJAChange(file) {
            console.log(file)
        },
        handleXAChange(file) {
            console.log(file);
        },
        handleKjChange(file) {
            console.log(file)

        },
        beforeJAUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'application/pdf' || rawFile.type == 'application/vnd.ms-powerpoint' || rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || rawFile.type == 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        handleRemove(file, uploadFiles) {
            if (file.response.data) {
                this.delFileList.push(file.response.data)
            }
        },

        submitForm() {
            this.lessonInfo.beginTime = this.setHms(this.lessonInfo.beginTime);
            this.lessonInfo.endTime = this.setHms(this.lessonInfo.endTime);
            this.lessonInfo.teamuseList = [];
            this.lessonInfo.guideUsersList = [];
            var fileList = [];
            this.lessonInfo.fileUrls = ''
            this.jAFileList.forEach((e) => {
                if (e.response.code == 1) {
                    fileList.push(e.response.data);
                }
            })
            this.xAFileList.forEach((e) => {
                if (e.response.code == 1) {
                    fileList.push(e.response.data);
                }
            })
            this.kJFileList.forEach((e) => {
                if (e.response.code == 1) {
                    fileList.push(e.response.data);
                }
            })
            this.xTFileList.forEach((e) => {
                if (e.response.code == 1) {
                    fileList.push(e.response.data);
                }
            })
            this.lessonInfo.teamUsers = this.lessonInfo.teamuseList.toString()
            this.lessonInfo.guideUsers = this.lessonInfo.guideUsersList.toString()
            this.$refs["form"].validate(valid => {
                if (valid) {
                    var obj = JSON.parse(JSON.stringify(this.lessonInfo));
                    obj.fileUrls = fileList.toString()
                    obj.type = 1
                    delete obj.teamuseList
                    delete obj.guideUsersList
                    if (this.lessonId) {
                        delete obj.jaFiles
                        delete obj.kjFiles
                        delete obj.xtFiles
                        lessonUpdate(obj).then(res => {
                            if (res.data.code == 1) {
                                this.jAFileList = []
                                this.xAFileList = []
                                this.kJFileList = []
                                this.xTFileList = []
                                this.delFileList.forEach(e => {
                                    delLessonFile({ fileUrl: e });
                                })
                                this.queryLessonInfo()
                                this.$message.success("编辑成功");

                            }
                        })
                    }

                }
            });
        },

        handleRelease() {
            if (this.jAFileList.length === 0 &&
              this.xAFileList.length === 0 &&
              this.kJFileList.length === 0 &&
              this.xTFileList.length === 0) {
                this.$message.error("请上传备课文件");
                return
            }
            lessonEnd({ lessonId: this.lessonId}).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("备课完成");
                    this.queryLessonInfo();
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
    }
};
</script>
<style scoped>
.course-container{
    width: 100%;
    height: auto;
    background-color: #fff;
    padding-left: 15px;
    box-sizing: border-box;
    padding-bottom: 10px;
    padding-right: 10px;
}
.lesson-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
}
.top-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    font-weight: bold;
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #ff7f2e;
}
.flex-item:last-child{
    margin-left: auto;
}
.column-title{
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #ff7f2e;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.column-status{
    width: auto;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    padding: 0 6px 0 6px;
    background-color: #a2ef4d;
    font-size: 12px;
    text-align: center;
    color: #e87b17;
}
.column-status-fb{
    width: auto;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    padding: 0 6px 0 6px;
    background-color: #e87b17;
    font-size: 12px;
    text-align: center;
    color: #a2ef4d;
}
.column-btn{
    padding-right: 10px;
    display: flex;
}
.btn{
    width: auto;
    height: 20px;
    border: 1px solid #ff7f2e;
    color: #ff7f2e;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 10px;
    padding-left: 5px;
    padding-right: 5px;
}
.base-info-container{
    display: flex;
    width: 100%;
    height: 200px;
    padding-bottom: 10px;
    padding-top: 10px;
}
.base-info-content{
    width: calc(100% - 320px);
    padding-right: 160px;
    box-sizing: border-box;
}
.base-info-cover{
    width: 320px;
    height: auto;
    padding-right: 10px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}
.info-lesson-title{
    width: 100%;
    height: auto;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

}
.info-item-column{
    display: flex;
    width: 100%;
    height: 24px;
    div{
        font-size: 14px;
        line-height: 24px;
    }
}
.info-label{
    width: 70px;
}
.info-item-level{
    padding-left: 50px;
}

.file-info-container{
    width: 100%;
    height: auto;
}
.file-container{
    display: flex;
    width: 100%;
    height: auto;
    padding-top: 10px;
    border-bottom: 2px solid #a7a7a7;
}
.file-type{
    width: 60px;
    font-size: 15px;
}
.file-classify{
    width: 56px;
    height: 24px;
    line-height: 24px;
    background-color: #93d2f3;
    color: #3f3f3f;
    margin: auto;
    text-align: center;
    font-size: 14px;
    border-radius: 10px;
}
.file-list{
    width: calc(100% - 60px);
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 10px;
    padding-right: 20px;
    box-sizing: border-box;
}
.file-item:hover{
    color: #ff7f2e!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
}
.file-view{
    width: 30px;
    height: 100%;
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}


/*编辑*/
.avatar-uploader .avatar {
    width: 240px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.avatar-uploader /deep/ .el-upload {
    width: 240px;
    height: 152px;
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 240px;
    height: 152px;
    text-align: center;
}

</style>

